import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useStores } from '../stores'
import { Button, Col, Collapse, Divider, Row, Space, Typography } from 'antd'
import { FAQ } from '../stores/FAQ'
import Page from './Page'
import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import { Metrics } from '../components/Metrics'
import { collections } from '../stores/collections'
import { MobileStickyContent } from '../components/MobileStickyContent'
import { MintButton } from '../components/MintButton'

const { Panel } = Collapse
const { Text, Title } = Typography

const LandingPage = observer(() => {
  const navigate = useNavigate()

  const [totalSuply, setTotalSupply] = useState(0)
  const [maxSupply, setMaxSupply] = useState(0)

  const { store, configProvider } = useStores()
  const collection = collections[configProvider.getChainConfig().chainId].find(colllection => colllection.featured === true)
  const chainInfo = store.chainInfo

  useEffect(() => {
    if (collection === undefined) return
    if (chainInfo.blockNumber === 1) return

    const fetch = async (): Promise<void> => {
      const [total, max] = await store.fetchSupplyInfo(collection.address)
      setTotalSupply(total)
      setMaxSupply(max)
    }
    void fetch()
  }, [store, collection, configProvider, chainInfo])

  return <Page>
    <MobileStickyContent />
    {collection !== undefined && (
      <div className={'intro-nft-section'}>
        <div className={'pd-top-page'}>
          <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            <Row justify='space-between'>
              <Col sm={24} xs={24} md={24} lg={11}>
                <Row className={'campaign-slogan mg-bt-responsive'}>
                  <Title>{collection.campaignSlogan}</Title>
                </Row>
                <Row className={'mg-bt-responsive'}><Text>{collection.descriptionLanding}</Text></Row>
              </Col>
              <Col offset={1} sm={0} xs={0} md={0} lg={12} style={{ justifyContent: 'center' }}>
                <Row style={{ marginBottom: '40px' }}>
                  <img src={((collection.coverImage) != null) ? collection.coverImage : collection.image}
                  style={{ width: '100%', height: 'auto' }} alt={'lock'} />
                </Row>
                <Row style={{ marginBottom: '40px' }} justify='center'>
                  <MintButton mintBtnClassName='hide-on-mobile' size='large' />
                  <Button size='large' className='hide-on-mobile' onClick={() => navigate(`collection/${collection.address}`)}>VIEW COLLECTION</Button>
                  <Col offset={1} sm={24} xs={24} md={24} lg={0}>
                    <img src={((collection.coverImage) != null) ? collection.coverImage : collection.image}
                      style={{ width: '100%', height: 'auto' }} alt={'lock mobile'} />
                  </Col>
                </Row>
                <Row justify='center'>
                  <Metrics firstTitle={'TOTAL MINTED'} secondTitle={'TOTAL SUPPLY'} firstValue={totalSuply} secondValue={maxSupply} />
                </Row>
              </Col>
            </Row>
          </Space>
        </div>
      </div>
    )}
    <div className={'FAQ-section'} id="faq">
      <div style={{ paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%' }}>
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col><Title style={{ fontFamily: 'PP Neue Machina' }}>FAQ</Title></Col>
            </Row>
            <Divider orientation="left"></Divider>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              style={{ marginBottom: '5%', width: '-webkit-fill-available' }}>
              <Col style={{ width: '-webkit-fill-available' }}>
                <Collapse defaultActiveKey={['1']}
                  expandIcon={({ isActive }) => (isActive !== true)
                    ? <PlusOutlined style={{ fontSize: 26, marginTop: 5 }} />
                    : <MinusOutlined style={{ fontSize: 26 }} />}
                  bordered={false}
                >
                  {FAQ.map((faq, index) => {
                    return (<Panel header={<Title level={3}>{faq.question}</Title>}
                      key={index}
                      className='FAQ-collapse-panel'>
                      <faq.response/>
                    </Panel>)
                  })}
                </Collapse>
              </Col>
            </Row>
          </Row>
        </Space>
      </div>
    </div>
  </Page >
}
)

export default LandingPage
